import styled from 'styled-components';
import { units } from '../../../helpers/styles/units';
import { colors } from '../../../constants/Colors';
import { Input } from '../../../components/Input';
import { typography } from '../../../helpers/styles/typography';
import { FontWeight } from '../../../constants/Styles/fontWeight';
import { Button } from '../../../components/Button';
import { Select } from '../../../components/Select';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${units(20)};
  padding-top: ${units(20)};
  padding-bottom: ${units(69)};
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 75%;

  gap: ${units(12)};
`;

export const SwitchBlock = styled(MainWrapper)`
  gap: ${units(8)};
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${units(334)};

  padding-left: ${units(12)};
`;

export const StyledInput = styled(Input)`
  font-weight: ${FontWeight.REGULAR};
  letter-spacing: 0.8px;

  background-color: ${colors.light};

  ${typography(10)};
`;

export const IdInfo = styled.div`
  font-weight: ${FontWeight.MEDIUM};

  color: ${colors.greyDark};
  background-color: ${colors.light};

  ${typography(10)};
`;

export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: ${units(3)};
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: ${units(8)};
  padding: ${units(12)};
  max-width: ${units(334)};
`;

export const InpurWrapper = styled.div`
  display: flex;
  gap: ${units(8)};
  align-items: flex-end;
`;

export const StyledSelect = styled(Select)`
  background-color: ${colors.light};
  height: ${units(28)};

  & .label {
    color: ${colors.greyDark};
  }

  margin-bottom: ${units(0)};
`;

export const MapButton = styled(StyledButton)`
  height: ${units(28)};
  min-width: ${units(102)};
  max-width: ${units(102)};
  padding-top: ${units(12)};
`;

export const Subtitle = styled.div`
  font-weight: ${FontWeight.MEDIUM};
  color: ${colors.greyDark};
  ${typography(10)};
`;

export const ButtonRoot = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 20;

  display: flex;
  flex-direction: column;
  margin-left: -${units(12)};

  width: 100%;
  width: -moz-available;
  width: -webkit-fill-available;
  width: fill-available;

  background-color: ${colors.light};
  border-top: 1px solid ${colors.grey40};
`;
